import * as React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Sidebar from "./../Sidebar";
import { Main, FilterDiv } from "./elements";

import Header from "./../Header";

const objectTypes = [
  { title: "PDF", _id: "pdf" },
  { title: "Image", _id: "image" },
  { title: "Timeline event", _id: "timelineEvent" },
];

export const sortBy = (data, field) => {
  return data.sort((a, b) => {
    if (a[field] || a.title > b[field] || b.title) {
      return 1;
    }
    if (a[field] || a.title < b[field] || b.title) {
      return -1;
    }
    return 0;
  });
};

const Layout = ({ children, filterBy }) => {
  const [selectedFilter, setSelectedFilter] = React.useState("");
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allSanityPerson {
        nodes {
          _id
          title
          alphabetizeBy
        }
      }
      allSanityKeyword {
        nodes {
          title
          _id
        }
      }
      allSanityMediaType {
        nodes {
          title
          _id
        }
      }
    }
  `);

  const makeList = (type, name) => (
    <ul>
      {type.map((x, index) => (
        <li
          key={index}
          id={x._id}
          className={selectedFilter === x._id ? "selected" : ""}
        >
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              setSelectedFilter(x._id);
              filterBy(name, x._id);
            }}
          >
            {x.title}
          </a>
        </li>
      ))}
    </ul>
  );

  const people = sortBy(data.allSanityPerson.nodes, "alphabetizeBy");
  const keywords = sortBy(data.allSanityKeyword.nodes, "title");
  const mediaTypes = sortBy(data.allSanityMediaType.nodes, "title");
  return (
    <React.Fragment>
      <Header
        siteTitle={
          data.site.siteMetadata.title || `Bob Stein Archives Timeline`
        }
      />
      <div>
        <Main>
          <Sidebar></Sidebar>
          <div>
            <FilterDiv>
              <div>
                <h3>Choose a filter:</h3>
                <h3>
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedFilter("");
                      filterBy("clear");
                    }}
                  >
                    or clear all filters
                  </a>
                </h3>
              </div>
              <div>
                <h3>People:</h3>
                {makeList(people, "person")}
              </div>
              <div>
                <h3>Keywords:</h3>
                {makeList(keywords, "keyword")}
              </div>
              <div>
                <h3>Media types:</h3>
                {makeList(mediaTypes, "mediaType")}
              </div>
              <div>
                <h3>Object types:</h3>
                {makeList(objectTypes, "objectType")}
              </div>
            </FilterDiv>
            {children}
          </div>
        </Main>
        <footer></footer>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
